import { useEffect, useState } from 'react';
import MaintenanceConfig from './MaintenanceConfig';

const MAINTENANCE_CHECK_INTERVAL_MS = 1000;

const useMaintenanceWindow = () => {
  const [isMaintenanceActive, setIsMaintenanceActive] = useState(
    MaintenanceConfig.shouldShowMaintenanceBanner()
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsMaintenanceActive(MaintenanceConfig.shouldShowMaintenanceBanner());
    }, MAINTENANCE_CHECK_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, []);

  return isMaintenanceActive;
};

export default useMaintenanceWindow;
